import React from 'react';
import { Typography, Box } from '@mui/material';

const InstructionText = ({ 
  text = undefined,
  variant = "body2",
  sx = {},
  role = "note",
  ariaLabel = "Required field completion instruction",
  ...props 
}) => {
  return (
    <Box 
      sx={{ 
        mb: 2, 
        mt: 1,
        ...sx 
      }} 
      role={role}
      aria-label={ariaLabel}
      {...props}
    >
      <Typography 
        variant={variant}
        sx={{ 
          fontWeight: 500,
          color: 'text.primary',
          fontSize: '0.95rem',
          fontStyle: 'italic'
        }}
      >
        Pakisagutan ang lahat ng may (<span style={{color: 'red'}}>*</span>) na bahagi.
      </Typography>
    </Box>
  );
};

export default InstructionText;
